G.WorldMapAppearFlow = G.WorldMapAppearFlow || {};

const _createFlowMgr = function() {
    // imports
    let payloadChecker = null;
    let saveStateMgr = null;
    // let treasureHuntMgr = null;
    // let settings = null;
    // let dailyRewardMgr = null;

    let initialized = false;

    const doneCheckes = {
        daily: false,
        homescreen: false,
    };

    // let checkNumber = 0;

    const onPopUpReqested = new Phaser.Signal();
    const onOpenGate = new Phaser.Signal();
    const minutesUntilPayloadExpires = 72 * 60;


    return {
        onPopUpReqested,
        onOpenGate,
        // eslint-disable-next-line no-use-before-define
        cleanup,
        // eslint-disable-next-line no-use-before-define
        startFlow,
    };

    function init() {
        // fill imports
        payloadChecker = G.WorldMapAppearFlow.payloadChecker;
        saveStateMgr = G.saveState;
        // treasureHuntMgr = G.TreasureHunt.treasureHuntMgr;
        // settings = G.json.settings;
        // dailyRewardMgr = G.Helpers.dailyRewardMgr;
        initialized = true;
    }

    function startFlow(lastLevelData) {
        if (!initialized) init();
        if (OMT.envData.payload) {
            const { payload } = OMT.envData;
            console.log(payload);
            if (payload) {
                payloadChecker.onPopUpReqested.add(onPopUpReqested.dispatch, onPopUpReqested);
                payloadChecker.onOpenGate.add(onOpenGate.dispatch, onOpenGate);

                const currentTime = new Date().getTime();
                let expiryTime = minutesUntilPayloadExpires;
                // if the payload has a prop for this, use it; otherwise use fallback
                if (payload.additions && payload.additions.expireTime) expiryTime = payload.additions.expireTime;

                // convert to ms since thats what Date.getTime uses
                const expiryTimeInMs = (expiryTime * 60) * 1000;
                // if the time between now and when the payload is sent exceeds the current time, its expired.
                // however, we don't care about this if its not a bot message
                const hasExpired = currentTime - payload.timeSent > expiryTimeInMs && OMT.bots.entryPointIsBotMsg && !(payload.additions && payload.additions.restoreProgression);

                if (hasExpired) {
                    // clear the current payload
                    OMT.envData.rejectPayload();
                    // if its expired, we push a window to tell the player it has expired.
                    G.sb('pushWindow').dispatch(['BotRewardExpired', expiryTime], null, null, true);
                } else {
                    payloadChecker.checkPayloadAtWorld(payload);
                }
            }
        }

        // checkNews();
        /* eslint-disable no-use-before-define */
        checkDaily();
        checkTreasureHuntReward(lastLevelData);
        checkMysteryGift(lastLevelData);
        checkEvents();
        /* eslint-enable no-use-before-define */

        // checkNumber++;
    }

    function cleanup() {
        onPopUpReqested.removeAll();
        payloadChecker.cleanup();
    }
    /*
    function checkNews() {
      var newsData = settings.newsPopUp;
      if (!newsData) return;

      if (!saveStateMgr.wasNewsAlreadySeen(newsData.version)) {
        onPopUpReqested.dispatch(["newsUpdate", newsData]);
        saveStateMgr.markNewsAsSeen(newsData.version);
      }
    }
    */

    function checkMysteryGift(lastLevelData) {
        /* mystery gift window pops up on either:
         *  1) the player has mystery gifts (streak > 0) and they have expired, or
         *  2) building a streak that is < 4
         */

        if (!G.MYSTERYGIFT) return;

        if (saveStateMgr.mysteryGift_getCurrentStreak() > 0 &&
            !saveStateMgr.mysteryGift_isModeReady() &&
            saveStateMgr.mysteryGift_getRemainingGiftCooldown() === 0) {
            onPopUpReqested.dispatch('mysteryGiftStreakIncrese');
        } else if (lastLevelData && lastLevelData.mysteryGiftStreakIncrease && saveStateMgr.mysteryGift_getCurrentStreak() < 4) {
            onPopUpReqested.dispatch('mysteryGiftStreakIncrese');
        }
    }

    async function checkDaily() {
        if (doneCheckes.daily) return;

        const loginStats = saveStateMgr.getLoginStats();
        if (!loginStats.firstDay) {
            doneCheckes.daily = true;
            const dayToShow = await G.Helpers.dailyRewardMgr.reportVisit();
            if (dayToShow !== null) {
                let extraText = '';
                let extraTextDoubled = '';

                const dailyGifts = dayToShow.getGifts();

                if (dailyGifts[0][0].indexOf('coin') === 0) {
                    extraText = OMT.language.getText('More Coins!');
                    extraTextDoubled = OMT.language.getText('Even more Coins!');
                } else {
                    // eslint-disable-next-line no-lonely-if
                    if (
                        dailyGifts[0][1] > 1 ||
                        dailyGifts.length > 1
                    ) {
                        extraText = (`${OMT.language.getText('%#% Boosters').replace('%#%', '2')}!`);
                        extraTextDoubled = (`${OMT.language.getText('%#% Boosters').replace('%#%', '4')}!`);
                    } else {
                        extraText = `${OMT.language.getText('1 Booster')}!`;
                        extraTextDoubled = (`${OMT.language.getText('%#% Boosters').replace('%#%', '2')}!`);
                    }
                }
                if (dailyGifts) {
                    onPopUpReqested.dispatch(['dailyReward', dayToShow, function() {
                        onPopUpReqested.dispatch(['gift', {
                            reason: G.GiftUI.Constants.GiftReasons.DailyReward,
                            placement: G.BuildEnvironment.adPlacements.doubleDailyReward,
                            monetiseType: game.incentivised() && dayToShow.isDoubleable() ? 'double' : false,
                            adTracking: {
                                requestEvent: 'VideoAdWatchDailyReward',
                            },
                            twoFrameOpen: G.OMTsettings.elements.gifts.twoFrameOpen,
                            resourceTracking: {
                                itemType: 'Reward',
                                itemId: 'NewDailyReward',
                            },
                            showGingy: false,
                            showTitleBar: false,
                            giftBoxType: 'retro',
                            customExtraText: extraText,
                            customExtraTextDoubled: extraTextDoubled,
                            shareable: true,
                            autoOpen: true,
                            overlay: true,
                            autoOpenDelay: 1600,
                            coinFeedback: false,
                            incentivisedSharing: false,
                            skipGiftProcessing: true,
                            onlyOneBox: true,
                            hideShowMainHighscorePanel: false,
                            buttonsOffset: {
                                x: 0,
                                y: -55,
                            },
                            gifts: G.Utils.clone(dailyGifts),
                        }], undefined, G.WindowMgr.LayerNames.Base, true);
                    }], undefined, G.WindowMgr.LayerNames.Base);
                }
            }
        }
    }

    function checkTreasureHuntReward(lastLevelData) {
        // imports
        const { treasureHuntMgr } = G.TreasureHunt;

        let lastLevelCollectedGems = 0;
        if (lastLevelData && lastLevelData.treasureHuntCollectedGems) {
            lastLevelCollectedGems = lastLevelData.treasureHuntCollectedGems;
        }

        if (treasureHuntMgr.isRewardAvailable()) {
            onPopUpReqested.dispatch(['treasureHuntMainReward', {
                lastLevelCollectedGems,
                onClaimCallback: treasureHuntMgr.markRewardAsClaimed,
            }]);
        }
    }

    /**
     * Checks events and whether or not it needs to push a window
     */
    async function checkEvents() {
        // if (await OMT.feature.getEventPostcardFeature(true)) {
        //     if (!G.saveState.data.eventMsg || G.saveState.data.eventMsg.indexOf(G.OMTsettings.postcardEvent.eventId) === -1) {
        //         G.sb('pushWindow').dispatch(['eventPostcardPromo'], null, G.WindowMgr.LayerNames.Base);
        //     }
        // }
    }
};

G.WorldMapAppearFlow.flowMgr = _createFlowMgr();